import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import Shell from '../Shell';
import { api } from '../api';
import { useToast } from '../ToastContext';
import { useAuth } from '../AuthContext';

export default function Settings() {
  const [tenant, setTenant] = useState(null);
  const [form, setForm] = useState({ name: '', timezone: '', baseCurrency: 'USD' });
  const [saving, setSaving] = useState(false);
  const toast = useToast();
  const { user } = useAuth();

  useEffect(() => {
    api.getTenant().then((t) => {
      setTenant(t);
      setForm({ name: t.name || '', timezone: t.timezone || 'UTC', baseCurrency: t.baseCurrency || 'USD' });
    });
  }, []);

  async function save() {
    setSaving(true);
    try {
      const t = await api.patchTenant(form);
      setTenant(t);
      toast.push('Settings saved');
    } catch (e) {
      toast.push(e.message, { variant: 'error' });
    } finally { setSaving(false); }
  }

  if (!tenant) return <Shell title="Settings"><div className="empty">Loading…</div></Shell>;

  const isAdmin = user?.role === 'Admin';

  return (
    <Shell title="Settings" subtitle="Tenant-wide configuration">
      <div className="card" style={{ maxWidth: 680 }}>
        <h3 className="card-title">Company</h3>
        <div className="row">
          <label className="field"><span className="label">Company name</span>
            <input className="input" value={form.name} disabled={!isAdmin} onChange={(e) => setForm({ ...form, name: e.target.value })} />
          </label>
        </div>
        <div className="row">
          <label className="field"><span className="label">Base currency</span>
            <select className="select" value={form.baseCurrency} disabled={!isAdmin} onChange={(e) => setForm({ ...form, baseCurrency: e.target.value })}>
              {['USD', 'EUR', 'GBP', 'INR', 'AED', 'SGD'].map((c) => <option key={c}>{c}</option>)}
            </select>
          </label>
          <label className="field"><span className="label">Timezone</span>
            <input className="input" value={form.timezone} disabled={!isAdmin} onChange={(e) => setForm({ ...form, timezone: e.target.value })} />
          </label>
        </div>
        {isAdmin && (
          <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
            <button className="btn" onClick={save} disabled={saving}>{saving ? 'Saving…' : 'Save'}</button>
          </div>
        )}
      </div>

      <div className="card" style={{ maxWidth: 680, marginTop: 16 }}>
        <h3 className="card-title">Other settings</h3>
        <ul style={{ paddingLeft: 0, listStyle: 'none', margin: 0 }}>
          <li style={{ padding: '8px 0', borderBottom: '1px solid var(--border-1)' }}>
            <Link to="/settings/email-inbox">Email mailboxes →</Link>
            <div style={{ fontSize: 12, color: 'var(--ink-500)' }}>Connect Gmail / Outlook / IMAP for ingest and dispatch.</div>
          </li>
          <li style={{ padding: '8px 0' }}>
            <Link to="/settings/data-retention">Data retention →</Link>
            <div style={{ fontSize: 12, color: 'var(--ink-500)' }}>Control how long email bodies are cached for instant load. Higher retention = higher S3 cost.</div>
          </li>
        </ul>
      </div>
    </Shell>
  );
}
